import * as React from "react";
import * as _ from "lodash";
import { IPatientExamination, IPatientSystemiscExamination } from "@curefit/ehr-common";
import { IPrescription, IAppointmentScheduleResponse } from "@curefit/care-common";
import MedicinePrescriptionView from "../prescription/medicine/MedicinePrescriptionView";
import LabTests from "../prescription/labTests/LabTests";
import LifestyleAdvice from "../prescription/advice/LifestyleAdvice";
import AdditionalInstructions from "../prescription/instructions/AdditionalInstructions";
import { AppConstants } from "../../utils/AppConstants";
import IMedicineType from "../../models/staticData/IMedicineType";
import ISystemicExaminationStaticData from "../../models/staticData/ISystemicExaminationStaticData";
import ISystemicExaminationStaticDataValues from "../../models/staticData/ISystemicExaminationStaticDataValues";
import AppUtils from "../../utils/AppUtils";

interface PatientPrescriptionProps {
    staticSystemicExams: { [key: string]: ISystemicExaminationStaticDataValues };
    systemicExams?: IPatientSystemiscExamination[];
    generalExams?: IPatientExamination[];
    staticMedicineTypes: IMedicineType[];
    prescription: IPrescription;
    caseSummary: string;
    consultationData: any;
}
export const PatientPrescription = (props: PatientPrescriptionProps) => {
    let staticSystemicExams = props.staticSystemicExams;
    let systemicExams = props.systemicExams;
    let generalExams = props.generalExams;
    let staticMedicineTypes = props.staticMedicineTypes;
    let diagnosis, labTests, referrals, symptoms, hopi, advices, addtionalInstruc, followUp, diffDiagnosis, doctorAdvices, publicNotes, privateNotes, medicines, prescriptionInstructions, diagnosticAssessments, prescribedBodyParts;
    if (!_.isEmpty(props.prescription)) {
        diagnosis = props.prescription.prescriptionDiagnosis && props.prescription.prescriptionDiagnosis.diagnosticsList && props.prescription.prescriptionDiagnosis.diagnosticsList.length > 0 && props.prescription.prescriptionDiagnosis.diagnosticsList;
        labTests = props.prescription.prescriptionLabTest && props.prescription.prescriptionLabTest.labTestList;
        symptoms = props.prescription.chiefComplaints && props.prescription.chiefComplaints.patientComplaints
            && props.prescription.chiefComplaints.patientComplaints.length > 0 && props.prescription.chiefComplaints.patientComplaints;
        diagnosticAssessments = props.prescription.diagnosticsAssessments && props.prescription.diagnosticsAssessments.assessments;
        referrals = props.prescription.prescriptionInstructions && props.prescription.prescriptionInstructions.referralInfoSet;
        followUp = props.prescription.prescriptionInstructions && props.prescription.prescriptionInstructions.followupInfoSet;
        doctorAdvices = props.prescription.prescriptionAdvice && props.prescription.prescriptionAdvice.advice && props.prescription.prescriptionAdvice.advice.length > 0
            && props.prescription.prescriptionAdvice.advice;
        addtionalInstruc = referrals && referrals.length > 0 || followUp && followUp.length > 0;
        publicNotes = props.prescription.chiefComplaints && props.prescription.chiefComplaints.doctorPublicNotes && props.prescription.chiefComplaints.doctorPublicNotes.publicNotes;
        privateNotes = props.prescription.chiefComplaints && props.prescription.chiefComplaints.doctorPrivateNotes && props.prescription.chiefComplaints.doctorPrivateNotes.privateNotes;
        medicines = props.prescription.prescriptionMedicines && props.prescription.prescriptionMedicines.prescriptionMedicationList;
        prescriptionInstructions = props.prescription.prescriptionInstructions;
        prescribedBodyParts = props.prescription.prescriptionBodyPartsCateredTo && props.prescription.prescriptionBodyPartsCateredTo.bodyPartsWorkedOn
    }
    return (<div>
        {
            diffDiagnosis && <div className="differential-diagnosis-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">DIFFERENTIAL DIAGNOSIS</div>
                <div className="in-blk symptom-text">{diffDiagnosis}</div>
            </div>
        }
        {
            props.caseSummary && <div className="case-summary-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">CASE SUMMARY</div>
                <div className="in-blk symptom-text">{props.caseSummary}</div>
            </div>
        }
        {
            prescribedBodyParts && <div className="diagnosis-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">BODY PARTS CATERED TO</div>
                {prescribedBodyParts.map((data: any) => {
                    return <div key={data.code}>
                        <div className="highlighted-text diagnosis-text in-blk">{data.displayValue}</div>
                        <div className="sub-text in-blk">{data.comments}</div>
                    </div>;
                })}
            </div>
        }
        {
            (symptoms || !_.isEmpty(publicNotes) || !_.isEmpty(privateNotes)) && <div className="symptom-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">CHIEF COMPLAINTS</div>
                {symptoms && symptoms.map((symptom, index) => {
                    return <div key={index}>
                        <div className="in-blk highlighted-text symptom-text">{symptom.complaint.displayValue}</div>
                        <div className="in-blk placeholder-text">{symptom.duration && symptom.duration.count && symptom.duration.unit && `since `}</div>
                        <div className="sub-text in-blk symptom-date" style={{ marginLeft: "20px" }}>
                            {symptom.duration && symptom.duration.count && symptom.duration.unit &&
                                `${symptom.duration.count} ${AppConstants.FrequencyUnit[symptom.duration.unit]}`}
                        </div>
                        <div className="sub-text in-blk" style={{ marginLeft: "20px", color: "grey" }}>{symptom.comment ? symptom.comment : ""}</div>
                    </div>;
                })}
                {!_.isEmpty(publicNotes) &&
                    <div>
                        <div className="in-blk highlighted-text symptom-text">Public Notes</div>
                        <br />
                        <div className="sub-text in-blk symptom-date" dangerouslySetInnerHTML={{ __html: AppUtils.formatStrongTag(publicNotes) }} />
                    </div>
                }

                {!_.isEmpty(privateNotes) &&
                    <div>
                        <div className="in-blk highlighted-text symptom-text">Private Notes</div>
                        <br />
                        <div className="sub-text in-blk symptom-date" dangerouslySetInnerHTML={{ __html: AppUtils.formatStrongTag(privateNotes) }} />
                    </div>
                }
            </div>
        }
        {/* {
            hopi && <div className="hopi-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">HISTORY OF PRESENTING ILLNESS</div>
                <div className="in-blk symptom-text">{hopi}</div>
            </div>
        } */}
        {
            !_.isEmpty(generalExams) && !_.isEmpty(generalExams.generalToggleList) && <div className="systemic-examinations-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">GENERAL EXAMINATIONS</div>
                <div className="highlighted-text systemic-exam-text in-blk" style={{ marginRight: "20px" }}>
                    {!_.isEmpty(generalExams.generalToggleList) ? generalExams.generalToggleList.examinationsList
                        && generalExams.generalToggleList.examinationsList.map(item => item).join(", ") : null}
                </div>
                {
                    !_.isEmpty(generalExams.generalToggleList.comments) &&
                    <div className="sub-text in-blk">
                        ( {generalExams.generalToggleList.comments} )
                    </div>
                }
            </div>
        }
        {/* {
            systemicExams && <div className="systemic-examinations-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">SYSTEMIC EXAMINATIONS</div>
                {_.map(staticSystemicExams, (data, index) => {
                    let exam = systemicExams.filter(item => item.systemicExaminationCode === data.internalValue);
                    if (exam.length > 0) {
                        let examSet: string[] = [];
                        let isNormal = exam[0].isNormal !== undefined && exam[0].isNormal !== null ? "Normal" : "";
                        return <div key={index}>
                            <div className="highlighted-text systemic-exam-text in-blk" style={{ marginRight: "10px" }}>{`${data.displayValue} : `}</div>
                            <div className="sub-text in-blk">
                                <span className={"examination-tag-set"}>
                                    {`${AppUtils.getSystemicExamDisplayValuesFromInternalValues(exam[0].systemicExaminationTagsSet, data.exams).join(", ")}`}
                                </span>
                                {
                                    !_.isEmpty(exam[0].comment) &&
                                    <span className={"examination-comments"}>( {exam[0].comment} )</span>
                                }
                                {
                                    !_.isEmpty(isNormal) &&
                                    <span className={"normal-tag"}>{isNormal}</span>
                                }
                            </div>
                        </div>;
                    }
                })}
            </div>
        } */}
        {
            diagnosis && <div className="diagnosis-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">DIAGNOSIS</div>
                {diagnosis.map((data, index) => {
                    return <div key={index}>
                        <div className="highlighted-text diagnosis-text in-blk">{!_.isEmpty(data.code) ? `${data.code} -` : ""} {(data.disease || {}).displayValue}</div>
                        <div className="sub-text in-blk">{data.diagnosticDetails}</div>
                    </div>;
                })}
            </div>
        }
        {
            medicines &&
            <div className="medicines-container summary-subcontainer">
                <div className="medicines-label summary-subheader brandon-bold">MEDICINES</div>
                <MedicinePrescriptionView medicinePrescriptionList={medicines} additionalInstructions={prescriptionInstructions}
                    staticMedicineTypes={staticMedicineTypes} />
            </div>
        }
        {diagnosticAssessments ? (
            <div className="labTest-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">LAB TESTS</div>
                <LabTests diagnosticAssessments={diagnosticAssessments} />
            </div>) : (

                labTests != null && labTests.length > 0 &&
                <div className="labTest-container summary-subcontainer">
                    <div className="labTest-label summary-subheader brandon-bold">LAB TESTS</div>
                    <LabTests labTests={labTests} />
                </div>
            )
        }
        {/* {
            advices != null && advices.length > 0 &&
            <div className="labTest-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">LIFESTYLE ADVICE</div>
                <LifestyleAdvice advices={advices} />
            </div>
        } */}
        {
            doctorAdvices != null && doctorAdvices.length > 0 &&
            <div className="labTest-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">DOCTOR ADVICE</div>
                <LifestyleAdvice doctorAdvices={doctorAdvices} />
            </div>
        }
        {
            addtionalInstruc &&
            <div className="labTest-container summary-subcontainer">
                <div className="labTest-label summary-subheader brandon-bold">ADDITIONAL INSTRUCTIONS</div>
                <AdditionalInstructions followUps={followUp} referrals={referrals} />
            </div>
        }
    </div>)
}
interface PatientConsultationSummaryProps {
    consultation: IAppointmentScheduleResponse;
    staticMedicineTypes: IMedicineType[];
    staticSystemicExams: ISystemicExaminationStaticData;
    caseSummary: string;
    consultationData: any;
    prescription: any
    editEnabled: boolean
    editClickHandler: (e: any) => void;
}
const PatientConsultationSummary = (props: PatientConsultationSummaryProps) => {

    let staticMedicineTypes = props.staticMedicineTypes;
    let consultation = props.consultation;
    let staticSystemicExams = props.staticSystemicExams && props.staticSystemicExams.values;
    let systemicExams = props.prescription && props.prescription.systemicExaminations;
    // let systemicExams = props.consultation.patientSystemicExaminationList;
    let generalExams = props.prescription && props.prescription.generalExaminations;
    // let generalExams = props.consultation.patientGeneralExaminationList;
    let doctorName = `${
        !_.isEmpty(consultation.doctor.prefix)
            ? consultation.doctor.prefix + " "
            : ""
        }${consultation.doctor.name}`;
    return (
        <div className="patient-consultation-summary-container">
            <div className="doctor-details-container summary-subcontainer">
                <div>
                    <div className="doctor-label summary-subheader brandon-bold">
                        DOCTOR
                    </div>
                    <div className="doctor-name-value-label">{doctorName}</div>
                </div>
                <div onClick={props.editEnabled && props.editClickHandler}
                    className={`actions-container ${!props.editEnabled && "disabled"}`}>
                    <img src="../../../images/edit.svg" />
                        EDIT
                </div>
            </div>
            {props.prescription !== null &&
                props.prescription !== undefined && (
                    <PatientPrescription
                        staticMedicineTypes={staticMedicineTypes}
                        prescription={props.prescription}
                        staticSystemicExams={staticSystemicExams}
                        systemicExams={systemicExams}
                        generalExams={generalExams}
                        caseSummary={props.caseSummary}
                    />
                )}

            {!props.prescription && props.caseSummary ? (
                <div className="case-summary-container summary-subcontainer">
                    <div className="labTest-label summary-subheader brandon-bold">
                        CASE SUMMARY
                    </div>
                    <div className="in-blk symptom-text">{props.caseSummary}</div>
                </div>
            ) : null}

            {(!props.prescription && !props.caseSummary) ? (
                <div className={"no-prescription-tagged-container"}>
                    {"No prescription details found"}
                </div>
            ) : null}
            {/*<PatientPrescription*/}
            {/*staticMedicineTypes={staticMedicineTypes}*/}
            {/*prescription={consultation.prescription}*/}
            {/*staticSystemicExams={staticSystemicExams}*/}
            {/*systemicExams={systemicExams}*/}
            {/*generalExams={generalExams}*/}
            {/*caseSummary={props.caseSummary}*/}
            {/*/>*/}
        </div>
    );
};

export default PatientConsultationSummary;
